import { createBrowserRouter } from "react-router-dom";
import Admin from "./pages/Admin/Admin";
import OrderHistory from "./pages/OrderHistory/OrderHistory";
import MainLayout from "./components/MainLayout/MainLayout";
import {
  CurrencyExchange,
  EditNote as EditNoteIcon,
} from "@mui/icons-material";
import { History as HistoryIcon } from "@mui/icons-material";
import { AttachMoney as AttachMoneyIcon } from "@mui/icons-material";
import { AdminPanelSettings as AdminPanelSettingsIcon } from "@mui/icons-material";
import { Update as UpdateIcon } from "@mui/icons-material";
import AdminExpense from "./pages/AdminExpense/AdminExpense";
import Expense from "./pages/Expense/Expense";
import OrderTakingOld from "./pages/OrderTakingOld/OrderTakingOld";
import ExpiryTracking from "./pages/ExpiryTracking/ExpiryTracking";

export const routerConfig = [
  {
    path: "/",
    title: "Order Taking",
    IconComp: EditNoteIcon,
    element: <OrderTakingOld />,
    hidden: true,
  },
  {
    path: "/order-taking",
    title: "Order Taking",
    IconComp: EditNoteIcon,
    element: <OrderTakingOld />,
  },
  {
    path: "/order-history",
    title: "Order history",
    IconComp: HistoryIcon,
    element: <OrderHistory />,
  },
  {
    path: "/expense",
    title: "Expense",
    IconComp: AttachMoneyIcon,
    element: <Expense />,
  },
  {
    path: "/admin-expense",
    title: "Admin Expense",
    IconComp: CurrencyExchange,
    element: <AdminExpense />,
    isAdminPage: true,
  },
  {
    path: "/admin",
    title: "Admin",
    IconComp: AdminPanelSettingsIcon,
    element: <Admin />,
    isAdminPage: true,
  },
  {
    path: "/expiry-tracking",
    title: "Expiry Tracking",
    IconComp: UpdateIcon,
    element: <ExpiryTracking />,
  },
];

const router = createBrowserRouter(
  routerConfig.map((v) => ({
    ...v,
    element: (
      <MainLayout title={v.title} key={v.path}>
        {v.element}
      </MainLayout>
    ),
  })),
);

export default router;
